import React from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import _ from 'lodash';

import veracodeLogo from '~/images/sca-veracode-logo-white.png';

const NotFoundPage = () => {
  return (
    <div className="container pt+">
      <Helmet title={`Page Not Found`} />
      <div className="grid">
        <div className="grid__item push--col-1-5 col-3-5">
          <div className="panel panel--default text--center pb pt+">
            <div className="panel__body">
              <div className="text--center mb+">
                <img src={veracodeLogo} className="vc-spinner" />
                <h2>The security company for software developers</h2>
              </div>
              <h1 className="mb">404</h1>
              <i className="sci sci__lemon sci--xl" />
              <p className="">That URL is a lemon. Try one of the links below.</p>
              <div className="mb">
                <div className="">
                  <Link to="/" className="btn btn--block">
                    <i className="sci sci__home sci--fw" /> Go Home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
